function addToCart(element) {
  const loader = element.getElementsByClassName("button__preloader")[0];

  element.getElementsByClassName("button__text")[0].style.opacity = 0.5;
  loader.style.display = "block";

  const product = element.closest("[data-js-product-add-to-cart]");
  const formData = {
    items: [
      {
        id: product.dataset.variantid,
        quantity: 1,
      },
    ],
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      loader.style.display = "none";
      element.getElementsByClassName("button__text")[0].style.display = "none";
      element.getElementsByClassName("button__text added")[0].style.display = "block";

      setTimeout(() => {
        element.getElementsByClassName("button__text added")[0].style.display = "none";
        element.getElementsByClassName("button__text")[0].style.opacity = 1;
        element.getElementsByClassName("button__text")[0].style.display = "block";
      }, 1500);

      if (location.pathname.indexOf("cart") > -1) {
        location.reload();
      } else {
        updateCartCounter();
      }

      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  Analytics().pushDataLayerAddToCart(element);
}

function updateCartCounter() {
  fetch(window.Shopify.routes.root + "cart.js")
    .then((response) => {
      return response.json();
    })
    .then((response) => {
      const buttonCartCount = document.querySelector("[data-header-cart-count]");
      const buttonCartTotal = document.querySelector("[data-header-cart-total]");

      buttonCartCount.innerHTML = response.item_count;
      buttonCartTotal.innerHTML = `€${(response.total_price/100).toFixed(2).replace(".",",")}`;
    });
}
function updateShippingProgressBar() {
  const notice = document.querySelector('shipping-notice.cart-notice');
  const fill = document.getElementById('shipping-progress-fill');
  if (!notice || !fill) return;

  const threshold = Number(notice.getAttribute('data-free-shipping'));
  const total = Number(notice.getAttribute('data-cart-total-amount'));
  if (!threshold) return;

  const pct = Math.min(100, Math.round((total / threshold) * 100));
  fill.style.width = pct + '%';
}

document.addEventListener('DOMContentLoaded', () => {
  updateShippingProgressBar();

  const subtotal = document.getElementById('AjaxCartSubtotal');
  if (subtotal) {
    new MutationObserver(() => {
      setTimeout(updateShippingProgressBar, 100);
    }).observe(subtotal, { childList: true, subtree: false });
  }
});